"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(current, staged) {
  return current !== staged;
};

exports.default = _default;
module.exports = exports.default;